import { IState } from '../../../../../store/types';
import { getAudioById, isUserGroupsLoaded } from '../../../../../store/models/selectors';
import { connect } from 'react-redux';
import { Audio } from '../components/Audio';
import { IAudioEvents, IAudioFields } from '../components/types';
import { AudioEvents } from './events';
import { getCurrentAudioId } from '../../../../../store/current-video/selectors';
import { TAudioType } from '../../../../../store/models/types';
import { IAudioHOCProps } from './types';

const mapStateToProps = (
  state: IState
): IAudioFields => {
  const audioId = getCurrentAudioId(state);
  const audio = audioId ? getAudioById(state, audioId) : null;
  const groupsLoaded = isUserGroupsLoaded(state)
  return {
    groupsLoaded,
    audioUrl: audio?.url,
    videoUrl: audio?.videoUrl,
    showPlayer: audio?.type === TAudioType.AUDIO,
  }
}

const mapDispatchToProps = (
  dispatch: any,
  {autoLoad}: IAudioHOCProps
): IAudioEvents => ({
    onLoad: autoLoad ? (audioId, groupId) => dispatch(AudioEvents.onLoad(audioId, groupId)) : () => {},
    onUpdateAudioPlayer: player => dispatch(AudioEvents.onUpdateAudioPlayer(player)),
    onUpdateGroupId: groupId => dispatch(AudioEvents.onUpdateGroupId(groupId)),
    onKeyDown: (event) => dispatch(AudioEvents.onKeyDown(event)),
    onKeyUp: (event) => dispatch(AudioEvents.onKeyUp(event)),
    onDocClick: () => dispatch(AudioEvents.onDocClick()),
  }
);

export const AudioHOC = connect(
  mapStateToProps,
  mapDispatchToProps
)(Audio);

AudioHOC.displayName = 'AudioHOC';
